// Do not edit.
import { ShaderStore } from "../Engines/shaderStore.js";
var name = "gpuUpdateParticlesPixelShader";
var shader = "#version 300 es\nvoid main() {\ndiscard;\n}\n";
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
/** @hidden */
export var gpuUpdateParticlesPixelShader = { name: name, shader: shader };
//# sourceMappingURL=gpuUpdateParticles.fragment.js.map